export default {
    getters: {
        getApiUrl: function() {

            //실서버일 경우 실서버 API endpoint return
            if(location.href.match(/process.bspojang/g)){
                return 'https://process.bspojang.com'
            }else if(location.href.match(/demo.hoxy/g)) {
                return 'https://demo.hoxy.io'
            }else if(location.href.match(/pg.packagehouse.co.kr/g)){
                return 'https://pg.packagehouse.co.kr'
            }else{
                return 'http://localhost:3333'
            }

        }
    }
}